import { Pipe, PipeTransform } from "@angular/core";
import { AmeritradePotentialTradesQuoteResponse } from "src/app/Models/AmeritradePotentialTradesQuoteResponse";

@Pipe({
  name: "tradeFilter",
  pure: false,
})
export class TradeFilterPipe implements PipeTransform {
  transform(
    items: AmeritradePotentialTradesQuoteResponse[],
    filter: string
  ): any {
    if (!items || !filter) {
      return items;
    }
    return items.filter((item) => item.symbol == filter);
  }
}
